// extracted by mini-css-extract-plugin
module.exports = {"container-switch":"switch_container-switch__MhDIf","switch":"switch_switch__1r10q","react-switch-bg":"switch_react-switch-bg__24QNk"};